import { CardContainer } from "@msys/ui";
import { Stack } from "@mui/material";
import { isComputedProp } from "../../doc-items/properties.js";
import { PropertyMappingSection } from "./PropertyMappingSection.js";
import { TemplateQuoteLinkedTemplateItemHeaderBox_ItemFragment } from "./TemplateQuoteLinkedTemplateItemHeaderBox.generated.js";

interface Props {
  docId: string;
  item: TemplateQuoteLinkedTemplateItemHeaderBox_ItemFragment;
  isEditable: boolean;
}

export function TemplateQuoteLinkedTemplateItemHeaderBox({
  docId,
  item,
  isEditable,
}: Props) {
  const { linkedQuoteTemplate } = item;
  if (!linkedQuoteTemplate) return null;

  const mappableProperties = linkedQuoteTemplate.rootItem.props2.filter(
    prop => !isComputedProp(prop)
  );
  const mappings = item.propertyMappings;

  return (
    <CardContainer isExpandable>
      <Stack direction={"column"} spacing={1} padding={1}>
        <PropertyMappingSection
          docId={docId}
          itemId={item.id}
          properties={mappableProperties}
          mappings={mappings}
          isEditable={isEditable}
        />
      </Stack>
    </CardContainer>
  );
}
